"use client"
import { Link, useNavigate } from "react-router-dom"
import "../styles/sidebarDono.css"
import logo from "../assets/logo.png"
import {
  FaChartBar,
  FaCreditCard,
  FaMoneyBill,
  FaFileAlt,
  FaSignOutAlt,
  FaBars,
  FaTimes,
  FaBell,
  FaPrint
} from "react-icons/fa"
import { useState, useEffect } from "react"

const SidebarDono = () => {
  const navigate = useNavigate()
  const [isMobile, setIsMobile] = useState(false)
  const [sidebarOpen, setSidebarOpen] = useState(false)

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768)
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const handleLogout = () => {
    localStorage.removeItem("token")
    localStorage.removeItem("user")
    navigate("/login")
  }

  return (
    <>
      {isMobile && !sidebarOpen && (
        <div className="menu-icon-dono" onClick={() => setSidebarOpen(true)}>
          <FaBars />
        </div>
      )}

      <div className={`sidebar-dono ${sidebarOpen ? "open" : ""}`}>
      {isMobile && (
          <FaTimes className="close-icon" onClick={() => setSidebarOpen(false)} />
        )}
        <div className="logo">
          <img src={logo || "/placeholder.svg"} alt="Logo A Senha" />
          
        </div>
        <ul>
          <li>
            <Link to="/dono/dashboard">
              <FaChartBar /> Dashboard
            </Link>
          </li>
          <li>
            <Link to="/dono/vendas">
              <FaCreditCard /> Vendas
            </Link>
          </li>
          <li>
            <Link to="/dono/financeiro-dono">
              <FaMoneyBill /> Financeiro
            </Link>
          </li>
          <li>
            <Link to="/dono/relatorio">
              <FaFileAlt /> Relatório
            </Link>
          </li>
          <li>
            <Link to="/dono/senhas-limpas">
              <FaPrint /> Senhas Limpas
            </Link>
          </li>
        </ul>
        <button className="logout-button" onClick={handleLogout}>
          <FaSignOutAlt /> Sair
        </button>
        
      </div>
    </>
  )
}

export default SidebarDono
